module.exports = __webpack_public_path__ + "img/icon-arrow-down.1d9bf68b.svg";